export default __webpack_public_path__ + "static/media/procurementValue3.502ee34f.png";